import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface MaintenancePageConfig {
  show: boolean;
  subtext?: string;
  start_time?: string;
  end_time?: string;
}

export interface BannerConfig {
  show: boolean;
  need_login?: boolean;
  applied_for?: {
    all: boolean;
    marketplace: boolean;
    workcover: boolean;
  };
  messages?: string[];
  message_head?: string;
  start_time?: string;
  end_time?: string;
}
export interface MaintenanceConfig {
  maintenance: MaintenancePageConfig;
  banner: BannerConfig;
  repeat: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  constructor(private http: HttpClient) {}

  getMaintenanceConfig(): Observable<MaintenanceConfig> {
    const url = `assets/maintenance.json?ts=${Date.now()}`;
    return this.http
      .get<MaintenanceConfig>(url)
      .pipe(catchError(() => of({ maintenance: { show: false }, banner: { show: false }, repeat: false })));
  }
}
